/**
 * 
 */

 function createOptionsUtfGrid(layer, jsonOptions) {

 	return {
            layers : layer.businessId,
            crs : L.CRS.EPSG4326,
            srs: "EPSG:4326",
            transparent : true,
            format : 'utfgrid',
            nom : (layer.serverName ? layer.serverName : layer.nom) + " utfgrid",
	    	tipus: layer.serverType,
	    	group: jsonOptions.group,  
	    	businessId: layer.businessId            
	}

 }

function loadVisualitzacioWmsLayer(layer){
	var defer = $.Deferred();
	var jsonOptions;
	var objLayer = {activa: false, layer: null};	
	var jsonOptions = InstamapsUtils.Dom.cleanOptions(layer.options);
		
	var optionsWMS = {
        layers : layer.businessId,
        crs : L.CRS.EPSG3857,
        transparent : true,
        format : layer.imgFormat,//'image/png'
    	version: layer.version,
    	tileSize:512,
       	opacity: layer.opacity,	    
    	nom : layer.serverName,
    	tipus: layer.serverType,
    	zIndex :  parseInt(layer.capesOrdre),
    	group: jsonOptions.group,
    	businessId: layer.businessId	        	
	}
	var wmsLayer = new L.tileLayer.betterWms(layer.url, optionsWMS);

	var optionsUtfGrid = {
            layers : layer.businessId,
            crs : L.CRS.EPSG4326,
            srs: "EPSG:4326",
            transparent : true,
            format : 'utfgrid',
            nom : layer.serverName + " utfgrid",
	    	tipus: layer.serverType,
	    	group: jsonOptions.group,
	    	//zIndex :  parseInt(layer.capesOrdre),	    
	    	businessId: layer.businessId            
	}
	var utfGridLayer = createUtfGridLayer(layer.url,optionsUtfGrid);
	utfGridLayer._map = map;
	if (!layer.capesActiva || true === layer.capesActiva || 'true' === layer.capesActiva){
		map.addLayer(wmsLayer);
		try{
			map.addLayer(utfGridLayer);		
			wmsLayer.options.utfGridLeafletId = utfGridLayer._leaflet_id;
		}catch(e){

		}
		objLayer.activa = true; 
	}
	
	if (!layer.capesOrdre){
		if(controlCapes){
			wmsLayer.options.zIndex = controlCapes._lastZIndex + 1;
		}
	}else{
		wmsLayer.options.zIndex = parseInt(layer.capesOrdre);
	}

	if(controlCapes){
		controlCapes.addOverlay(wmsLayer, wmsLayer.options.nom, true);
		controlCapes._lastZIndex++;
	}
	objLayer.layer = wmsLayer;
	defer.resolve(objLayer);	
	return defer.promise();
}

function loadVisualitzacioWmsLayerSenseUtfGrid(layer){
	
	var defer = $.Deferred();
	var optionsWMS = {
	        layers : layer.serverName,
	        crs : L.CRS.EPSG3857,
	        transparent : true,
	        format : layer.imgFormat,//'image/png'
	    	version: layer.version,
	    	tileSize:512,
	    	//    opacity: layer.opacity,	    
	    	nom : layer.serverName,
	    	tipus: layer.serverType,
	    	zIndex :  parseInt(layer.capesOrdre),	    
	    	businessId: layer.businessId	        	
	}
	var wmsLayer =L.tileLayer.betterWms(layer.url, optionsWMS);
	map.addLayer(wmsLayer);
	
	var jsonOptions;
	var objLayer = {activa: false, layer: null};
	if (true === layer.capesActiva || 'true' === layer.capesActiva){
		objLayer.activa = true;
	}
	
	jsonOptions = InstamapsUtils.Dom.cleanOptions(layer.options);
		
	var origen = InstamapsUtils.Mapa.getLeafletIdFromBusinessId(jsonOptions.origen, controlCapes);
    wmsLayer.options.zIndex = capesOrdre_sublayer;
	if(controlCapes){
		controlCapes.addOverlay(wmsLayer, wmsLayer.options.nom, true,origen);
	}
	
	objLayer.layer = wmsLayer;
	defer.resolve(objLayer);
	return defer.promise();
	
}

function createUtfGridLayer(url,options, isClickable){

	var utfGrid = new L.utfGrid(url, options);
	utfGrid._map = map;

	var clickable = (undefined !== isClickable && isClickable);
	if(clickable)
	{

		utfGrid.on('click', function (e) {
			if (e.data!=null){
	//			console.debug(e.data);
				
				jQuery('#bt_info_geojsonvt_close').on('click', function (e) {
	//				tancaFinestra();
					jQuery('#info_geojsonvt .div_popup_visor').html('');
					jQuery('#info_geojsonvt').hide();
				});
				
				var html ='';
				html+='<div class="popup_pres">';
				$.each( e.data, function( key, value ) {
	//				console.debug( key + ": " + value );
					if(key.indexOf("slot")==-1 && value!=undefined && value!=null && value != " "){
						//treiem caracter '_' del nom de la propietat
						key = key.replace('_', ' ');
						if (key != 'id' && key != 'businessId' && key != 'slotd50'){
							html += InstamapsUtils.Dom.getHtmlFromTxt(value,key,"width100");
						}
					}
				});
				html+= '</div>';
				
				//var html = '<p>Hello world!<br />This is a nice popup.</p>';
				jQuery('#info_geojsonvt .div_popup_visor').html(html);
				jQuery('#info_geojsonvt').show();
				
			}else{
				console.debug("null");
			}
		});

	}
	else
	{

		utfGrid.off('click');

	}
	
	return utfGrid;
}